import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import BaseAnswer from '../base-answer';
import { AnswerProvider, FeedbackAnswerSurvey } from '../../providers/answer-provider';
import { FeedbackQuestionSurvey } from '../../providers/question-provider';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FeedbackQuestionFactoryService } from '../../questions/feedback-question-factory.service';
import { FeedbackQuestionService } from '../../questions/feedback-question.service';
import { Feedback } from '../../../common/models/feedback';
import { MatRadioButton, MatRadioGroup, MatRadioModule } from "@angular/material/radio";
import { FlexLayoutModule } from "@angular/flex-layout";
import { NgForOf } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { MatButton } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: 'app-feedback-borg-answer',
  templateUrl: 'feedback-borg-answer.component.html',
  styleUrls: ['./feedback-borg-answer.css', './../feedback-answer.css'],
  imports: [
    ReactiveFormsModule,
    MatRadioModule,
    FlexLayoutModule,
    NgForOf,
    TranslateModule,
    MatButton,
    MatIconModule,
  ],
  standalone: true
})
export class FeedbackBorgAnswerComponent extends BaseAnswer implements OnInit {
    public form: FormGroup;

    @Input()
    public override hasAnsweredQuestion = false;

    @Input()
    public override feedback: Feedback = {} as Feedback;

    @Input()
    public override question: FeedbackQuestionSurvey = {} as FeedbackQuestionSurvey;

    @Input()
    public override previousAnswers: any = null;

    @Input()
    public answeredAnswers: any = null;

    @Output()
    public override onAnswerChange: EventEmitter<any> = new EventEmitter();

    @Output()
    public override onNextQuestionClicked: EventEmitter<{answers: FeedbackAnswerSurvey[]; isBack: boolean}> = new EventEmitter();

    public selectedAnswer: any = null;

    constructor(
        public override answerProvider: AnswerProvider,
        public override feedbackQuestionFactoryService: FeedbackQuestionFactoryService,
        public override feedbackQuestionService: FeedbackQuestionService,
        private fb: FormBuilder
    ) {
        super(answerProvider, feedbackQuestionFactoryService, feedbackQuestionService);

        this.form = this.fb.group({
            borg: new FormControl(null),
        });
    }

    public override ngOnInit(): void {
        super.ngOnInit();

        // find all answers for this question
        const data: any = this.feedbackQuestionService.getAnsweredAnswersByQuestionId(this.question['id']);
        this.selectedAnswer = data && data['answers'].length > 0 ? data['answers'][0] : null;

        if (this.selectedAnswer) {
            this.answerChanged(this.selectedAnswer);
        }
    }
}
